import { createFileRoute } from "@tanstack/react-router";
import { AgentsScreen } from "./-agents/AgentsScreen";

export const Route = createFileRoute("/$workspace/$project/agents")({
  staticData: { title: "Agents" },
  component: AgentsScreen,
});
